export class IntroJsStep {
    public element: Element;
    public intro: string;
    public title: string;
    public position: string;
}
